import { useEffect, useState } from 'react';
import { Post } from 'lib/types';
import { useApi } from 'lib/contexts/ApplicationState';
import { Project } from 'lib/types/projects';
import { Chip, IconButton } from '@mui/material';
import { A } from 'components/A';
import { buildProjectPath } from 'lib/helpers';
import { SaveToProjectListButton } from 'components/SaveToList/SaveToProjectListButton';
import AddCircleRounded from '@mui/icons-material/AddCircleRounded';

interface Props {
    post: Post;
}

export const PostProjects = ({ post }: Props) => {
  const API = useApi();

  const [projects, setProjects] = useState<Project[] | undefined>([]);

  useEffect(() => {
    const getProjects = async () => {
      const p = await API.getProjectsForPost(post.id);
      setProjects(p);
    };

    getProjects();
  }, [API, post?.id]);

  return (
    <>
      <>
        <div className="flex flex-wrap md:flex-nowrap items-center">
          <div className="w-full md:w-4/5 py-2">
            <ul className="flex flex-wrap gap-2 list-none">
              {projects?.map((p) => (
                <Chip
                  key={p.id}
                  size="small"
                  label={(
                    <A
                      href={buildProjectPath(p)}
                      className="text-white font-bold"
                    >
                      {p.name}
                    </A>
                  )}
                  // @ts-ignore
                  color="alpineTeal"
                />
              ))}
              <IconButton
                aria-label="Add project"
                // @ts-ignore
                color="alpineTeal"
                sx={{ padding: 0 }}
              >
                <AddCircleRounded />
                <SaveToProjectListButton styling="ml-1 text-sm font-semibold flex align-center" itemId={post.id} itemType="Post" text="Add to project" context="project" />
              </IconButton>
            </ul>
          </div>
        </div>
      </>
    </>
  );
};
